import swal from 'sweetalert';
import { differenceInYears, parseISO } from "date-fns"
import { getMobileOperatingSystem } from './mobile';

export const msgAlert = (title, text, button, closeOnClickOutside) => {
  swal({
    title,
    text,
    closeOnClickOutside,
    button
  });
}

export const convertUTCtoLocal = (d) => {
  let date = new Date(d);
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export const convertUTCtoLocalFullDate = (d) => {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let date = new Date(d);
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = day + ' ' + month + ', ' + year + ' - ' + hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export const convertUTCtoLocalDate = (d) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let date = new Date(d);
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  var strTime = day + ' ' + month + ', ' + year;
  return strTime;
}

export const getAge = dt => {
  if(dt) {
    const date = parseISO(dt);
    const age = differenceInYears(new Date(), date);
    return age;
  }
}

function getMinimumVersion(allowedVersion) {
  if(!!allowedVersion)
    return allowedVersion;

  const device = getMobileOperatingSystem();
if(device === "ios")
    return "4.0.7"
  else if(device === "android")
    return "6.0.9"
  else 
    return "0.0.0"
}

export function compareVersions(appVersion, allowedVersion = undefined) {
  const isDev = process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE === 'dev';
  console.log(isDev);

  if(isDev)
    return true

  const appVersionSplit = appVersion?.split('.').map(Number) || []
  const minVersionSplit = getMinimumVersion(allowedVersion)?.split('.').map(Number) || []
  
  const [major1, minor1, patch1] = appVersionSplit;
  const [major2, minor2, patch2] = minVersionSplit;
  
  if (major1 > major2) return true;
  if (major1 < major2) return false;

  if (minor1 > minor2) return true;
  if (minor1 < minor2) return false;

  return patch1 >= patch2;
}